import type { LiteralValues } from '@/utils/typing/literal-values.type';

export const FeatureCode = {
    // SHARED
    INTERCOM: 'intercom',

    // ANALYSE
    BASELOAD_DATASOURCE: 'baseloadDatasource',
    EXTENSIVE_TIMESERIES_BI_DASHBOARD: 'extensiveTimeseriesBIdashboard',
    ANNOTATED_WATER_LEAKAGE_ALERT_CREATION: 'AnnotatedWaterLeakageAlertCreation',
    SEN_ANALYSIS_MODELS: 'senAnalysisModels',
    SEN_ANALYSIS_COMPOSITE: 'senAnalysisComposite',
    SEN_ANALYSIS_CONVERSION: 'senAnalysisConversion',
    SEN_ANALYSIS_WEATHER_DATA: 'senAnalysisWeatherData',
    RECOMMENDED_ACTION: 'recommendedAction',
    ENERGY_SIGNATURE: 'energySignature',
    THERMAL_COMFORT: 'thermalComfort',
    PHOSPHOR_ICONS: 'phosphorIcons',
    RECOMMENDED_ACTIONS_SAVINGS: 'recommendedActionsSavings',
    BUILDING_BASELOAD_POWER_MEASURES: 'buildingBaseloadPowerMeasures',
    DATABOARDS_NEW_LANDING: 'databoardsNewLanding',

    // GATE
    IPMVP_MODEL: 'IpmvpModel',
    CONTRACT_POWER_OPTIMIZATION_BLOC: 'contractPowerOptimizationBloc',
    DISTRIBUTOR_METADATA: 'distributorMetadata',
    MANUAL_READING_UNIT: 'manualReadingUnit',
    IOT_SUPERVISION: 'iotSupervision',
    CONTRACT_POWER_OPTIMIZATION_PAGE: 'contractPowerOptimizationPage',
    NEW_COMPLETENESS: 'newCompleteness',
    NEW_ANALYSIS_COMPLETENESS: 'newAnalysisCompleteness',

    // REPORTING
    BUSINESS_INDICATOR_ADVANCEMENT_WIDGET: 'businessIndicatorAdvancementWidget',
    REPARTITION: 'repartition',
    DEET: 'deet',
    AUTOMATON: 'automaton',
    DEPRECATED_DEET: 'deprecated_deet',
    MIP: 'mip',
    MIP_BULK_SCENARIO_EDITION: 'mip_bulk_scenario_edition'
} as const;
export type FeatureCode = LiteralValues<typeof FeatureCode>;
